const Routes = {
  FEED: "/",
  LOGIN: "/auth/login",
  SIGNUP: "/auth/signup",
  CREATE_PROFILE: "/profile/create_profile",
  PROFILE: "/profile/user_profile",
  CHAT: "/chat"
};

export default Routes;
